import version from './version?text';

import Sheet from './Sheet';

const minify = (css        ) => '' + new Sheet(css);

import { newline } from './options';

const beautify = (css        , options          ) => {
	let cssText = '';
	for ( const line of new Sheet(css)[Symbol.iterator](options) ) { cssText += line + newline; }
	return cssText.slice(0, -newline.length);
};

export {
	version,
	Sheet,
	minify,
	beautify,
};

import Default from '.default';
export default /*#__PURE__*/Default({
	version,
	Sheet,
	minify,
	beautify,
});

                                          
